import Svg, { Circle, Defs, G, LinearGradient, Path, Stop } from 'react-native-svg'
/* SVGR has dropped some elements not supported by react-native-svg: filter */
const MangeUserIntroIcon = ({ width = 218, height = 214 }) => (
  <Svg width={width} height={height} fill="none">
    <Circle cx={100.666} cy={100} r={100} fill="#DF9F39" opacity={0.1} />
    <Circle cx={100.667} cy={100.001} r={72.727} fill="#DF9F39" opacity={0.1} />
    <G filter="url(#a)">
      <Circle cx={48} cy={132} r={20} fill="#00B259" />
    </G>
    <Path
      fill="url(#b)"
      fillRule="evenodd"
      d="M51.75 126c0 2.209-1.679 4-3.75 4-2.071 0-3.75-1.791-3.75-4s1.679-4 3.75-4c2.071 0 3.75 1.791 3.75 4Zm3.75 10.5c0 3.038-3.358 5.5-7.5 5.5-4.142 0-7.5-2.462-7.5-5.5s3.358-5.5 7.5-5.5c4.142 0 7.5 2.462 7.5 5.5Z"
      clipRule="evenodd"
    />
    <G filter="url(#c)">
      <Circle cx={40} cy={22} r={12} fill="#CE54F9" />
    </G>
    <Path
      fill="url(#d)"
      fillRule="evenodd"
      d="M42.25 18.4c0 1.326-1.007 2.4-2.25 2.4s-2.25-1.075-2.25-2.4S38.757 16 40 16s2.25 1.075 2.25 2.4Zm2.25 6.3c0 1.823-2.015 3.3-4.5 3.3s-4.5-1.477-4.5-3.3c0-1.822 2.015-3.3 4.5-3.3s4.5 1.478 4.5 3.3Z"
      clipRule="evenodd"
    />
    <G filter="url(#e)">
      <Circle cx={186} cy={152} r={10} fill="#ED617F" />
    </G>
    <Path
      fill="url(#f)"
      fillRule="evenodd"
      d="M187.875 149c0 1.105-.839 2-1.875 2s-1.875-.895-1.875-2 .839-2 1.875-2 1.875.895 1.875 2Zm1.875 5.25c0 1.519-1.679 2.75-3.75 2.75-2.071 0-3.75-1.231-3.75-2.75s1.679-2.75 3.75-2.75c2.071 0 3.75 1.231 3.75 2.75Z"
      clipRule="evenodd"
    />
    <G filter="url(#g)">
      <Circle cx={154} cy={68} r={20} fill="#52D6FF" />
    </G>
    <Path
      fill="url(#h)"
      fillRule="evenodd"
      d="M157.75 62c0 2.21-1.679 4-3.75 4-2.071 0-3.75-1.79-3.75-4s1.679-4 3.75-4c2.071 0 3.75 1.79 3.75 4Zm3.75 10.5c0 3.038-3.358 5.5-7.5 5.5-4.142 0-7.5-2.462-7.5-5.5s3.358-5.5 7.5-5.5c4.142 0 7.5 2.462 7.5 5.5Z"
      clipRule="evenodd"
    />
    <G filter="url(#i)">
      <Circle cx={100.665} cy={99.999} r={45.455} fill="#DF9F39" />
    </G>
    <G filter="url(#j)">
      <Circle cx={100.665} cy={99.999} r={45.455} fill="#DF9F39" />
    </G>
    <Path
      fill="url(#k)"
      d="m116.88 89.12-4.534-4.178a3.555 3.555 0 0 0-2.4-.942h-18.56a3.555 3.555 0 0 0-2.4.942l-4.533 4.178a5.333 5.333 0 0 0 7.538 7.538c.134-.146.258-.3.373-.462a5.333 5.333 0 0 0 8.302 0 5.329 5.329 0 0 0 4.151 1.984 5.33 5.33 0 0 0 4.151-1.984c.115.161.24.316.374.462a5.332 5.332 0 0 0 9.234-3.73 5.324 5.324 0 0 0-1.696-3.808Zm-24.498 11.627a8.884 8.884 0 0 1-7.716.284v9.636A5.333 5.333 0 0 0 90 116h8.888v-14.56a8.918 8.918 0 0 1-2.364.338 8.736 8.736 0 0 1-4.142-1.031Zm16.569 0a8.738 8.738 0 0 1-4.143 1.031 8.918 8.918 0 0 1-2.364-.338v3.893H106a1.779 1.779 0 0 1 0 3.556h-3.556V116h8.889a5.334 5.334 0 0 0 5.333-5.333v-9.636a8.882 8.882 0 0 1-7.715-.284Z"
    />
    <Defs>
      <LinearGradient id="b" x1={47.286} x2={57.031} y1={122.476} y2={144.846} gradientUnits="userSpaceOnUse">
        <Stop offset={0.011} stopColor="#fff" />
        <Stop offset={1} stopColor="#fff" stopOpacity={0.45} />
      </LinearGradient>
      <LinearGradient id="d" x1={39.571} x2={45.419} y1={16.286} y2={29.707} gradientUnits="userSpaceOnUse">
        <Stop offset={0.011} stopColor="#fff" />
        <Stop offset={1} stopColor="#fff" stopOpacity={0.45} />
      </LinearGradient>
      <LinearGradient id="f" x1={185.643} x2={190.515} y1={147.238} y2={158.423} gradientUnits="userSpaceOnUse">
        <Stop offset={0.011} stopColor="#fff" />
        <Stop offset={1} stopColor="#fff" stopOpacity={0.45} />
      </LinearGradient>
      <LinearGradient id="h" x1={153.286} x2={163.031} y1={58.476} y2={80.846} gradientUnits="userSpaceOnUse">
        <Stop offset={0.011} stopColor="#fff" />
        <Stop offset={1} stopColor="#fff" stopOpacity={0.45} />
      </LinearGradient>
      <LinearGradient id="k" x1={99.106} x2={110.632} y1={84.762} y2={123.956} gradientUnits="userSpaceOnUse">
        <Stop offset={0.011} stopColor="#fff" />
        <Stop offset={1} stopColor="#fff" stopOpacity={0.32} />
      </LinearGradient>
    </Defs>
  </Svg>
)
export default MangeUserIntroIcon
